import DetailContext from '@shared/components/utils/context/detailContext';
import DetailRelatedContainer from '@components/atoms/container/detailRelatedContainer';
import Focus from '@shared/types/enums/focus';
import MainContext from '@shared/components/utils/context/mainContext';
import RailsList from '@components/sections/list/railsList/railsList';
import { pushFocus, setFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch } from '@shared/store/hooks';
import { useCallback, useContext } from 'react';

export default function DetailRelated() {
  const dispatch = useAppDispatch();
  const { related } = useContext(DetailContext);

  // Actions

  const onMouseEnter = useCallback(() => {
    dispatch(setFocus([parseInt(`${Focus.RAILS_SUB_LIST}${0}`)]));
  }, []);

  const outOfBounds = useCallback(
    (_focus: Focus | number | string, exit?: string) => {
      if (exit === 'LEFT') {
        dispatch(pushFocus(Focus.MENU));
      }
    },
    []
  );

  return related ? (
    <MainContext.Provider
      value={{
        complete: true,
        onChangeElement: () => null,
        outOfBoundsAction: outOfBounds,
        setAsset: () => null,
      }}
    >
      <DetailRelatedContainer id={'detailRelated'}>
        <RailsList
          rails={[related]}
          onItemClick={() => null}
          onMouseEnter={onMouseEnter}
        />
      </DetailRelatedContainer>
    </MainContext.Provider>
  ) : null;
}
